export const SHARE_LINK_KEY = '@gologin:share-link';
